import { ModalState } from 'actions/modal/types/state';
import { Reducer } from 'redux';
import { ModalActions, ModalActionType } from '../actions/modalActions';
import { ModalMode } from '../types';


export const initialState: ModalState = {
  modalsShown: [false, false],
  meta: {
    mode: ModalMode.NONE,
  },
};

const modalsReducer: Reducer<ModalState, ModalActions> = (state = initialState, action: ModalActions) => {
  switch (action.type) {
    case ModalActionType.Open: {
      const index = action.payload ?? 0;
      const newModalShown = [...state.modalsShown];
      newModalShown[index] = true;

      return {
        ...state,
        modalsShown: newModalShown,
        meta: action.meta,
      };
    }
    case ModalActionType.Close: {
      const index = action.payload ?? 0;
      const modalsShown = [...state.modalsShown];

      modalsShown[index] = false;
      return {
        ...state,
        modalsShown,
      };
    }
    case ModalActionType.Resize:
      return {
        ...state,
        meta: {
          ...state.meta ?? {},
          size: action.payload,
        },
      };
    default:
      return state;
  }
}

export default modalsReducer;
